import { cn } from './chunk-UYYBXMNI.js';
import dynamicIconImports from 'lucide-react/dynamicIconImports.js';
import { lazy, Suspense } from 'react';
import { jsx } from 'react/jsx-runtime';

var fallback = /* @__PURE__ */ jsx("div", { className: "h-4 w-4" });
var Icon = ({ name, ...props }) => {
  const LucideIcon = lazy(dynamicIconImports[name]);
  return /* @__PURE__ */ jsx(Suspense, { fallback, children: /* @__PURE__ */ jsx(LucideIcon, { ...props, className: cn("h-4 w-4", props.className) }) });
};
Icon.displayName = "Icon";

export { Icon };
//# sourceMappingURL=chunk-VH4ICUUK.js.map
//# sourceMappingURL=chunk-VH4ICUUK.js.map